<template>
    <div>

        <b-row>
            <b-col cols="6" md="4">
                <b-form-group label="Hasil Gosokan ?" v-slot="{ ariaDescribedby }" :disabled="karatOpt.length != 0">
                    <b-form-radio v-model="gosok" :aria-describedby="ariaDescribedby" name="gosok-radios"
                        :value=true>Hilang</b-form-radio>
                    <b-form-radio v-model="gosok" :aria-describedby="ariaDescribedby" name="gosok-radios" :value=false>Tidak
                        Hilang</b-form-radio>
                </b-form-group>
            </b-col>
            <b-col cols="6" md="4">
                <b-form-group label="Ada Cap Karat ?" v-slot="{ ariaDescribedby }" :disabled="karatOpt.length != 0">
                    <b-form-radio v-model="cap" :aria-describedby="ariaDescribedby" name="cap-radios"
                        :value=true>Ya</b-form-radio>
                    <b-form-radio v-model="cap" :aria-describedby="ariaDescribedby" name="cap-radios"
                        :value=false>Tidak</b-form-radio>
                </b-form-group>
            </b-col>
            <b-col cols="6" md="4">
                <RadioAdaMerkPerusahaan
                    :isAdaMerkPerusahaan="isAdaMerkPerusahaan"
                    @isAdaMerkPerusahaan="$emit('isAdaMerkPerusahaan', $event)"
                    :disabled="karatOpt.length != 0"
                />
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col>
                <b-button variant="pgiBtn" v-if="karatOpt.length == 0" @click="$emit('kalkulasiKarat')" :disabled="isSubmitting"
                    class="mr-2">
                    Kalkulasi Karat
                </b-button>
                
                <b-button variant="deleteBtn" v-else @click="$emit('resetKarat')" :disabled="isSubmitting">
                    Reset Kalkulasi
                </b-button>
            </b-col>
        </b-row>


        <div v-if="IS_REJECT_GADAI">
            <b-alert show variant="warning">
                Mohon Maaf Barang Tidak Bisa Digadai!
            </b-alert>
        </div>

        <div v-else>
            <b-form-group label="Karat Emas">
                <b-row no-gutters>
                    <b-col cols="9">
                        <multiselect name="gadaiKaratEmas" v-model="input.karatEmas" :options="karatOpt"
                            :disabled="karatOpt.length == 0" :internal-search="true" :allow-empty="false" deselect-label=""
                            select-label="" label="name" placeholder="-- Pilih Karat Emas --" />
                    </b-col>
                </b-row>
            </b-form-group>
        </div>
    </div>
</template>

<script>
import RadioAdaMerkPerusahaan from './RadioAdaMerkPerusahaan.vue';

export default {
    components: {
        RadioAdaMerkPerusahaan,
    },
    props: {
        data: { required: true },
        input: { required: true },
        karatOpt: { required: true },
        isSubmitting: { required: true },
        optCapEmas: { required: true },
        optKemasanEmas: { required: true },
        role: { required: true },
        isBusy: { required: true },
        optPotonganTambahan: { required: true },
        karatOpt: { required: true },
        gosok : { required: true },
        cap : { required: true },
        // kwitansi : { required: true },
        isAdaMerkPerusahaan: {
            type: Boolean,
            required: true
        },
        IS_REJECT_GADAI: {
            type: Boolean,
            required: true
        },
    },

    // data(){
    //     return {
         
    //     }
    // },
    watch:{
        'gosok' : function(newVal) {
            this.$emit('gosok' , newVal)
        },
        'cap' : function(newVal) {
            this.$emit('cap' , newVal)
        },
        // 'kwitansi' : function(newVal) {
        //     this.$emit('kwitansi' , newVal)
        // },
    }
}
</script>